export default __webpack_public_path__ + "static/media/cse.e8179d29.png";